import sortBy from "utils/sorter"

const findAttendeeAssignment = (key, value, attendee) =>
  attendee.assignments.find(assignment => Number(assignment[key]) === Number(value))

export const attendeeAssignmentAreaBy = (key, value, attendee, areas) => {
  const attendeeArea = findAttendeeAssignment(key, value, attendee)
  return attendeeArea ? areas[Number(attendeeArea.areaId)] : null
}

export const assignedAttendeesBy = (key, value, attendees) =>
  attendees.filter(attendee => findAttendeeAssignment(key, value, attendee))

export const unassignedAttendeesBy = (key, value, attendees) =>
  attendees.filter(
    attendee => attendee.assignments.length === 0 || !findAttendeeAssignment(key, value, attendee)
  )

export const filterAttendees = (filterType, attendees, typeId) => {
  let atts = attendees

  if (filterType === "assigned") {
    atts = assignedAttendeesBy("typeId", typeId, attendees)
  } else if (filterType === "unassigned") {
    atts = unassignedAttendeesBy("typeId", typeId, attendees)
  }

  return sortBy("name", atts)
}
